module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALlJREFUeNpiZiAByMpK6/Lz8z0B4gefPn2+RKw+RhIteQOkhKFc/sePn34iRh8TA2mABYktRKwmUi0hC4xaMmoJ7QAjNJMZA6laItR7ATErlL0biL8RUL8cmGFXMgItkAJyntLQI66g4HoNxN9paMlZWHCBioswIGYjoGEaEHNC2aVA/IaA+jXA4PpCagH5AVQwQrmKQAMejOaTUUtGLcEAsOLnLxA/ppUlhkA8H9RiAWbEv8RqAggwADTkKiIu5Ha3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./img/plus-button.png
// module id = 879
// module chunks = 0